
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'AtrialFibrillationSymptomScore',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/AtrialFibrillationSymptomScore.vue